import React from 'react'
import './clicks.widget.scss'

import { numberWithCommas, numberWithPercent } from '../../../_utils/utils'
import { Card, Tooltip } from 'antd'

const PropsFragment = (props: any) => <>{props.children}</>

const ClicksWidget = ({ type, showType, yesterday, adYesterday }: any) => {
    const HoverWrapper = (yesterday.clicks ?? 0) <= 9999 ? PropsFragment : Tooltip

    return (
        <Card
            className={`dashboard-widget clicks-widget vsplit type-${type?.toLowerCase() ?? 'content'}`}
            title={showType !== false && type ? `${type} ` : 'Clicks (CTR)'}
            styles={{
                title: { textAlign: 'center' },
                body: { padding: 0 },
            }}
            size="small"
        >
            <div className="dashboard-widget-content">
                <div className="widget-body yesterday">
                    <div className="widget-sub-title">
                        <label>Yesterday</label>
                    </div>
                    <span className="clicks">
                        <HoverWrapper title={numberWithCommas(yesterday.clicks ?? 0)}>
                            <span>
                                {yesterday.clicks === undefined
                                    ? '--'
                                    : numberWithCommas(yesterday.clicks, yesterday.clicks > 9999 ? '0.0a' : undefined)}
                            </span>
                        </HoverWrapper>
                        <span>({yesterday.ctr === 0 ? '--' : numberWithPercent(yesterday.ctr)})</span>
                    </span>
                </div>
            </div>
        </Card>
    )
}

export default ClicksWidget
